module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h1', {
    staticClass: "navTitle"
  }, [_vm._v("Black Tom’s Red Army")]), _vm._v(" "), _c('h2', {
    staticClass: "navTocTitle"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    attrs: {
      "id": "tocList"
    }
  }, [_c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Cover")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter0",
      "title": "Title Page"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1",
      "title": "Dramatis Personae"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Dramatis Personae")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2",
      "title": "Prologue"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3",
      "title": "By the Drum and Monkey"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the Drum and Monkey")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4",
      "title": "Part One"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Part One")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5",
      "title": "By Guilsborough and Elsewhere"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Guilsborough and Elsewhere")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter6",
      "title": "By Guilsborough and Broad Moor"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Guilsborough and Broad Moor")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By East Farndon and Little Oxendon")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Broad Moor")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Dust Hill")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Broad Moor")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Part Two")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Dust Hill")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Marston Thrussel")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Naseby and Elsewhere")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Market Harborough")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the Phelps Farm, Clipston")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Leicester and Elsewhere")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Leicester and Elsewhere")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Leicester")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By London Way, Leicester")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the Fosse Way")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Phelps Farm, Clipston")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Part Three")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the New Model Army Encampment")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Canon’s March")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Lechlade")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Holt Church")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Holt and Elsewhere")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Widcombe")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the Guildhall")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the Guildhall and Elsewhere")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the Hot Baths")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Isle Moor")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Bristol Keep and Elsewhere")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Langport")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Bath")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Tormarton")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Wells")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Wells")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By the Bishop’s Palace")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Bristol Keep")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Bath")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Southgate")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Temple Gate")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("By Bath")])])]), _vm._v(" "), _c('li', {
    staticClass: "navTocItem"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "a-inner"
  }, [_vm._v("Copyright")])])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden",
      "id": "landmarks"
    }
  }, [_c('h2', [_vm._v("Guide")]), _vm._v(" "), _c('ol', {
    attrs: {
      "id": "landmarksList"
    }
  }, [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter0"
    }
  }, [_vm._v("Start Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter1"
    }
  }, [_vm._v("Dramatis Personae")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0